import { render, staticRenderFns } from "./TeachRoomPaper.vue?vue&type=template&id=3f32d0ae&"
import script from "./TeachRoomPaper.vue?vue&type=script&lang=js&"
export * from "./TeachRoomPaper.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomPaper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports